import { AxiosInstance } from 'axios'
import { BaseApi } from '@/api/BaseApi'
import { IPostBookmarkRequest } from '@/types/member/photogallery'

const PATH = {
  POST_BOOKMARK: '/api/mypage/member/photogalleries/bookmark',
} as const

export class PhotogalleryApi {
  baseApi: BaseApi
  constructor(axios: AxiosInstance) {
    this.baseApi = new BaseApi(axios)
  }

  /**
   * フォトギャラリーブックマーク
   * @param request
   */
  public async postBookmark(request: IPostBookmarkRequest): Promise<void> {
    await this.baseApi.post<IPostBookmarkRequest, Record<string, never>>(PATH.POST_BOOKMARK, request)
  }
}
